"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dirSync = void 0;
const fs = require("fs");
const os = require("os");
const path = require("path");
/**
 * Creates a temporary directory.
 */
function dirSync(options) {
    var _a;
    const name = fs.mkdtempSync(`${(_a = options === null || options === void 0 ? void 0 : options.path) !== null && _a !== void 0 ? _a : os.tmpdir()}${path.sep}`);
    return {
        name,
        removeCallback() {
            fs.rmSync(name, { recursive: true });
        },
    };
}
exports.dirSync = dirSync;
//# sourceMappingURL=tmp.js.map